export const arrayMove = (arr: {}[], from: number, to: number) => {
  arr.splice(to, 0, arr.splice(from, 1)[0])
}

export const removeElFromArray = (arr: string[], el: string): string[] => {
  let newArr = [...arr]
  const index = arr.indexOf(el)
  if (index !== -1) {
    newArr.splice(index, 1)
  }
  return newArr
}

export const addElToArray = (arr: string[], el: string): string[] => {
  let newArr = [...arr]
  const index = arr.indexOf(el)

  if (index === -1) {
    newArr.push(el)
  }
  return newArr
}
